<template>
  <!-- <div
    style="border-radius: 10px !important;"
    class="max-h item-group-kanban"
    :style="`background: ${colorGroup || '#333'}`"
  > -->
  <div
    style="border-radius: 8px !important;"
    class="max-h item-group-kanban sale-kanban-column pa-1"
    :class="{ 'sale-kanban-column-dark': isDark, 'sale-kanban-column-light': !isDark }"
  >
    <v-list-item
      style="max-height: 25px; cursor: grab; background: none !important;"
      class="kanban-selector px-2 mx-0"
    >
      <!-- <v-avatar color="#555" class="pa-1 mr-2" size="27">
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5 4.48242C5 3.23978 6.00736 2.23242 7.25 2.23242H17.75C18.9926 2.23242 20 3.23978 20 4.48242V21.4824C20 21.759 19.8478 22.0132 19.6039 22.1437C19.36 22.2742 19.0641 22.2599 18.834 22.1065L12.916 18.1612C12.6641 17.9932 12.3359 17.9932 12.084 18.1612L6.16603 22.1065C5.93588 22.2599 5.63997 22.2742 5.39611 22.1437C5.15224 22.0132 5 21.759 5 21.4824V4.48242ZM7.25 3.73242C6.83579 3.73242 6.5 4.06821 6.5 4.48242V20.081L11.2519 16.9131C12.0077 16.4092 12.9923 16.4092 13.7481 16.9131L18.5 20.081V4.48242C18.5 4.06821 18.1642 3.73242 17.75 3.73242H7.25Z" fill="#f2f2f2"/>
        </svg>
      </v-avatar> -->
      <v-list-item-content>
        <v-list-item-title class="kanban-column-title fonte mb-0 pb-0 not-selectable">
          <!-- <v-icon color="#f2f2f2">
            mdi-flag
          </v-icon> -->

          <!-- <span class="fonte white--text not-selectable">
          </span> -->
          {{ group.name.includes('salvo') ? 'Recentes' : group.name }} - ({{ list.length }})
        </v-list-item-title>
        <!-- <v-list-item-subtitle>
          <span class="fonte my-0 py-0 grey--text not-selectable fonteMini"> itens</span>
        </v-list-item-subtitle> -->
      </v-list-item-content>
      <v-list-item-action v-if="false">
        <v-menu v-if="!group.name.includes('salvo') " :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn x-small icon v-bind="attrs" v-on="on">
              <v-icon style="opacity: 0.3" color="white"
                >mdi-cog-outline</v-icon
              >
            </v-btn>
          </template>
          <v-card dark width="300">
            <v-color-picker
              dot-size="18"
              swatches-max-height="250"
              :swatches="swatches"
              show-swatches
              hide-canvas
              hide-mode-switch
              v-model="group.color"
              @input="saveColor(group)"
              hide-sliders
              hide-inputs
            ></v-color-picker>

            <v-list dense class="fonte pa-0 ma-0" color="transparent">
              <v-list-item @click="deleteKanban(group)">
                <v-list-item-title>Apagar Lista</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-list-item-action>
    </v-list-item>
    <div class="kanban-item-cont">
      <draggable
        v-for="(kanban, index) in kanbans"
        :key="kanban._id"
        :group="{ name: 'kanban-item' }"
        :animation="220"
        easing="cubic-bezier(0.2, 0, 0, 1)"
        handle=".move-card-item"
        ghost-class="kanban-ghost-itemm"
        chosen-class="kanban-card-chosen"
        drag-class="kanban-card-dragging"
        :group-name="group.name"
        :data-kanban-group="group.name"
        :class="`group-sale-${group.name}`"
        @end="itemKanbanChange($event, kanban, group.name)"
        style="border-radius: 10px !important;"
      >
        <SaleItem
          :data-index="index"
          :class="`sale-id-${kanban._id}`"
          :id="kanban._id"
          :data-id="kanban._id"
          :kanban="kanban"
        />
      </draggable>
      <draggable
        v-if="kanbans.length === 0"
        :group="{ name: 'kanban-item' }"
        :animation="220"
        easing="cubic-bezier(0.2, 0, 0, 1)"
        ghost-class="kanban-ghost-itemm"
        chosen-class="kanban-card-chosen"
        drag-class="kanban-card-dragging"
        :group-name="group.name"
        :data-kanban-group="group.name"
        style="min-height: 70vh;"
      />
      <div
        class="expande-horizontal centraliza"
        style="height: 100px;"
        v-intersect="onEndOfList"
        v-if="totalToShow >= 6 && totalToShow < list.length"
      >
        <v-btn small @click="onEndOfList" block>Carregar mais</v-btn>
      </div>
      <div
        v-if="totalToShow >= list.length && list.length > 6"
        class="expande-horizontal centraliza"
        style="height: 100px;"
        v-intersect="onEndOfList"
      >
        <span class="fonte fonteMini">fim!</span>
      </div>
    </div>
  </div>
</template>

<script>
import SaleItem from "./SaleItem.vue";
import draggable from "vuedraggable";
import { EventBus } from "@/main.js";

export default {
  name: "ElementContainer",
  props: ["value", "list", "group", "itemKanbanChange", "deleteKanban"],
  components: {
    SaleItem,
    draggable
  },
  data() {
    return {
      swatches: [
        ["#F44336", "#EF5350", "#EF9A9A"],
        ["#9C27B0", "#AB47BC", "#CE93D8"],
        ["#2196F3", "#42A5F5", "#90CAF9"],
        ["#4CAF50", "#66BB6A", "#A5D6A7"],
        ["#FFEB3B", "#FFEE58", "#FFF59D"]
      ],
      totalToShow: 6,
      itemsUpdated: []
    };
  },
  computed: {
    kanbans() {
      const list = this.value || this.list;
      const totalToShow = this.totalToShow;
      if (list) {
        return list.slice(0, totalToShow);
        // return list;
      } else {
        return [];
      }
    },
    colorGroup() {
      if (this.group.color) {
        return this.group.color.hex;
      } else {
        return "#333";
      }
    },
    isDark() {
      return localStorage.dark === "true";
    }
  },
  mounted() {
    const self = this;
    EventBus.$on(this.group.name, itensUpdateds => {
      self.$emit("input", itensUpdateds);
      self.$emit("change", itensUpdateds);
      // self.value = itensUpdateds;
      self.$forceUpdate();
    });
  },
  methods: {
    onEndOfList() {
      this.totalToShow += 4;
    },
    updateLocalGroup(kanbanUpdated) {
      const kanbans = localStorage.getItem("kanbans");
      if (kanbans) {
        const kanbansParsed = JSON.parse(kanbans);
        kanbansParsed.map(kanban => {
          if (kanban._id === kanbanUpdated._id) {
            kanban = kanbanUpdated;
          }
        });
        localStorage.setItem("kanbans", JSON.stringify(kanbansParsed));
      }
    },
    saveColor(group) {
      let newGroup = {
        ...group,
        color: group.color
      };
      delete newGroup.kanbans;
      this.updateLocalGroup(newGroup);

      this.$run("kanban/update", newGroup)
        .then(() => {
          // this.$store.dispatch("createGlobalMessage", {
          //   type: "success",
          //   message: `Cor do grupo atualizada`,
          //   timeout: 6000
          // });
        })
        .catch(error => {
          this.$store.dispatch("createGlobalMessage", {
            type: "info",
            message: error.response.data.message,
            timeout: 6000
          });
        });
    }
  }
};
</script>

<style>
.max-h {
  border-radius: 10px !important;
  overflow: hidden;
  max-height: calc(100vh - 40px) !important;
}

.item-group-kanban {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 18px !important;
  padding: 8px !important;
  margin-left: 6px;
  background: rgba(0, 0, 0, 0);
}
.sale-kanban-column {
  border: 1px solid transparent;
  box-shadow: 0 16px 34px rgba(7, 80, 89, 0.08);
  height: calc(100vh - 76px);
  min-height: calc(100vh - 76px);
  max-height: calc(100vh - 76px) !important;
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}
.sale-kanban-column-light {
  background:
    radial-gradient(circle at top left, rgba(37, 211, 102, 0.10), transparent 36%),
    #edf4f0 !important;
  border-color: rgba(7, 80, 89, 0.10);
}
.sale-kanban-column-dark {
  background:
    radial-gradient(circle at top left, rgba(37, 211, 102, 0.10), transparent 36%),
    #111b21 !important;
  border-color: #26343c;
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.24);
}
.kanban-selector {
  border-radius: 14px !important;
  min-height: 42px !important;
  margin-bottom: 8px !important;
  transition: background 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}
.kanban-selector:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(7, 80, 89, 0.08);
}
.sale-kanban-column-light .kanban-selector {
  background: rgba(255, 255, 255, 0.72);
}
.sale-kanban-column-dark .kanban-selector {
  background: #182229;
}
.kanban-column-title {
  color: #075e54 !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  letter-spacing: -0.01em;
}
.sale-kanban-column-dark .kanban-column-title {
  color: #e9edef !important;
}
.kanban-item-cont {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  overflow: auto;
  max-height: none;
  padding-top: 4px;
  padding-left: 2px;
  padding-right: 2px;
  flex-direction: column;
  background: rgba(0, 0, 0, 0);
  scroll-behavior: smooth;
}
.kanban-item-cont > div {
  position: relative;
  transition: transform 0.22s ease, opacity 0.22s ease;
}
.kanban-item-cont::-webkit-scrollbar {
  width: 8px;
  border-radius: 20px;
}

.kanban-item-cont::-webkit-scrollbar-track {
  background: rgba(7, 80, 89, 0.08);
  border-radius: 20px;
}

.kanban-item-cont::-webkit-scrollbar-thumb {
  background-color: #b9c9c1;
  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.sale-kanban-column-dark .kanban-item-cont::-webkit-scrollbar-track {
  background: #0b141a;
}
.sale-kanban-column-dark .kanban-item-cont::-webkit-scrollbar-thumb {
  background-color: #40515a;
  border-color: #0b141a;
}
.kanban-ghost-itemm {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 18px !important;
  padding-right: 0;
  overflow: hidden;
  opacity: 0.42 !important;
  transform: scale(0.98);
  background:
    repeating-linear-gradient(
      135deg,
      rgba(37, 211, 102, 0.18),
      rgba(37, 211, 102, 0.18) 8px,
      rgba(7, 94, 84, 0.10) 8px,
      rgba(7, 94, 84, 0.10) 16px
    ) !important;
  min-height: 86px;
  border: 1px dashed rgba(7, 94, 84, 0.38);
}
.kanban-card-chosen {
  transform: scale(1.015);
}
.kanban-card-dragging {
  transform: rotate(1.2deg) scale(1.025);
  opacity: 0.96;
  filter: drop-shadow(0 22px 34px rgba(0, 0, 0, 0.28));
}
.sale-kanban-column-light .kanban-ghost-itemm {
  border-color: rgba(7, 94, 84, 0.34);
}
.sale-kanban-column-dark .kanban-ghost-itemm {
  border-color: #3d5863;
  background:
    repeating-linear-gradient(
      135deg,
      rgba(37, 211, 102, 0.14),
      rgba(37, 211, 102, 0.14) 8px,
      rgba(61, 88, 99, 0.20) 8px,
      rgba(61, 88, 99, 0.20) 16px
    ) !important;
}
</style>
